export default __webpack_public_path__ + "static/media/kramer_off.ac2b711c.png";